<template>
    <div v-if="visible" class="checkboxes-form">
        <h4>{{ data.name.charAt(0).toUpperCase() + data.name.slice(1) }}</h4>
        <term v-for="checkbox in data.subCategories" :key="checkbox.id" v-model="values[checkbox.id]" :val="values[checkbox.id]" :id="checkbox.id">{{checkbox.name}}</term>
    </div>
</template>

<script>
    import Term from "./Term";
    export default {
        name: "CheckboxesForm",
        components: {Term},
        props: ["data", "value", "visible"],
        data() {

            let tempValues = {};

            if(this.data) {
                for(let i = 0; i < this.data.subCategories.length; i++) {
                    tempValues[this.data.subCategories[i].id] = (this.value.indexOf(this.data.subCategories[i].id) > -1) ? true : undefined;
                }
            }

            return {
                values: tempValues,
            };
        },
        updated() {

        },
        methods: {
            updateValues: function () {

                if(!this.data || !this.data.subCategories || !this.data.subCategories.length) {
                    this.$emit('update', { checkedValues : [], uncheckedValues : [] });
                    return;
                }

                let checkedValues = [];
                let uncheckedValues = [];

                for(let i = 0; i < this.data.subCategories.length; i++) {
                    if(this.values[this.data.subCategories[i].id]) {
                        checkedValues.push(this.data.subCategories[i].id);
                    }
                    else {
                        uncheckedValues.push(this.data.subCategories[i].id);
                    }
                }

                this.$emit('update', { checkedValues, uncheckedValues })

            }
        },
        watch: {
            "data.subCategories": {
                handler(val) {
                    if(!val || !val.length) { this.values = {}; return; }

                    let tempvalues = {};

                    for(let i = 0; i < val.length; i++) {

                        if(this.value.indexOf(val[i].id) > -1) {
                            tempvalues[val[i].id] = true;
                        }
                        else {
                            tempvalues[val[i].id] = false;
                        }
                    }

                    this.values = tempvalues;
                },
                deep: true
            },

            values: {
                handler() {
                    this.updateValues();
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss">

</style>